<div class="modal-container alarm-event">

  <div class="title-and-exit-button">

    <div class="title ellipsis-text" ellipsisTextTooltip>
      <div class="icon-bell-filed-white"></div>
      <app-event-type [type]="eventItem.eventTypeId"></app-event-type>
      {{eventItem.name | makeFirstLatterUppercase}}
<!--      <div class="time">{{time | date:'d, MMM, y hh:mm:ss'}}</div>-->
      <div class="time"> {{eventItem.alarm?.remarkInfo.alarmDate > 1 ? (eventItem.alarm?.remarkInfo.alarmDate | ticksToDate | date : 'MMM d, y, H:mm:ss' : 'UTC' ) : '' }}</div>
    </div>
    <div class="dialog-buttons-holder">
      <div class="exit-button icon-low-double-line" (click)="minimizeDialog()"></div>
      <div class="exit-button icon-x" (click)="closeDialog()"></div>
    </div>
  </div>
  <div class="modal-content">

    <div class="button button__small-secondery open-closed-button" appClickStopPropagation
         (click)="dismissClick()">{{'Events.table.dismissPopup.dismiss' | translate}}</div>

    <div class="alert-details">
      <div class="line-holder">
        <div class="details-row">
          <div class="detail-key">
            {{'Events.table.dismissPopup.links' | translate}}:
          </div>
          <div class="detail-value">
            {{eventItem.alarm?.remarkInfo.links ? eventItem.alarm?.remarkInfo.links: "no links"}}
          </div>
        </div>
        <div class="details-row">
          <div class="detail-key">
            {{'Events.table.dismissPopup.description' | translate}}:
          </div>
          <div class="detail-value">
            {{eventItem.alarm?.remarkInfo.description ? eventItem.alarm?.remarkInfo.description: "no description"}}
          </div>
        </div>
      </div>
      <div class="details-row">
        <div class="detail-key">
          {{'Events.table.dismissPopup.discussion' | translate}}
        </div>
          <textarea [(ngModel)]="discussionText" name="discussion" type="text" class="reason-input"></textarea>
      </div>
    </div>
  </div>
  <div class="buttons-container">
    <button class="button button__big-primary cancel-button" (click)="closeDialog()" [disabled]="false">
      {{'Events.table.dismissPopup.close' | translate}}
    </button>
  </div>
  <div *ngIf="isLoading">
    <mat-spinner class="loading"></mat-spinner>
  </div>
</div>

<p-confirmDialog key="{{popupKey}}" #cd>
  <p-footer>
    <button type="button" pButton [label]="'Events.table.dismissPopup.close' | translate" (click)="cd.reject()"></button>
    <button type="button" pButton [label]="'Events.table.dismissPopup.accept' | translate" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
